import { render } from "./P_InsectGlaive.vue?vue&type=template&id=b5b1d2c4&scoped=true"
import script from "./P_InsectGlaive.vue?vue&type=script&lang=js"
export * from "./P_InsectGlaive.vue?vue&type=script&lang=js"

import "./P_InsectGlaive.vue?vue&type=style&index=0&id=b5b1d2c4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b1d2c4"]])

export default __exports__